import React, { Fragment } from "react";
import PropTypes from "prop-types";
import throttle from "lodash/throttle";
import CenteredLoader from "./CenteredLoader";

class InfiniteScroller extends React.Component {
  static propTypes = {
    hasMore: PropTypes.bool,
    loadMore: PropTypes.func,
    loading: PropTypes.bool,
    renderLoadingIndicator: PropTypes.func,
    scrollOffset: PropTypes.number
  };

  static defaultProps = {
    loading: false,
    renderLoadingIndicator: () => <CenteredLoader />,
    scrollOffset: 240
  };

  constructor(props) {
    super(props);

    this.loadMore = this.loadMore.bind(this);
    this.shouldLoadMore = throttle(this.shouldLoadMore.bind(this), 500);

    this.state = {
      loading: false
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.shouldLoadMore);
    window.addEventListener("resize", this.shouldLoadMore);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.shouldLoadMore);
    window.removeEventListener("resize", this.shouldLoadMore);
  }

  shouldLoadMore() {
    if (!this.props.hasMore) return;
    if (!this.offsetMarker) return;

    const { top: offsetTop } = this.offsetMarker.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (offsetTop - this.props.scrollOffset <= windowHeight) {
      this.loadMore();
    }
  }

  loadMore() {
    if (!this.state.loading) {
      this.setState({ loading: true });
      this.props.loadMore().then(() => {
        this.setState({ loading: false });
      });
    }
  }

  render() {
    const { children, renderLoadingIndicator } = this.props;

    return (
      <Fragment>
        {children}
        <div ref={el => (this.offsetMarker = el)}>
          {this.state.loading && renderLoadingIndicator()}
        </div>
      </Fragment>
    );
  }
}

export default InfiniteScroller;



// WEBPACK FOOTER //
// ./src/components/InfiniteScroller.js